import { WelcomeModal } from '../welcome-modal/welcome-modal';

export function Globals() {
  return (
    <>
      <WelcomeModal />
    </>
  );
}
